<template>
      <v-row justify="center">
            <v-dialog v-model="dataValue" persistent max-width="510">
              <v-card>
                <v-card-title class="text-h5">
                    <p class="secondary--text font-weight-bold">התראה  </p>
                    <p class="fontGrey--text pr-3 font-weight-bold">
                    {{  alertMessage }}
                    <span>
                      יחד עם כל המספרים
                    </span>
                    </p>
                </v-card-title>
                <v-card-text v-if="displayOtpInput">
                  <v-otp-input v-model="otp" length="4" @finish="onFinish"></v-otp-input>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="success" plain text x-large class="text-h6 font-weight-bold" @click="sendOTPForUserDelete" >
                    המשך
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="fontGrey" text x-large class="text-h6 font-weight-bold" @click="dataValue = false">
                    חזור
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
</template>

<script>
import boolMixin from "@/mixins/boolMixin.js";

export default {
    name: 'AlertMessage',
    mixins: [boolMixin],
    props: {
        alertMessage: {
            type: String,
            required: true,
            default: ''
        }
    },
    data() {
        return {
            // displayAlert: false,
      displayOtpInput: false,
        }
    },
    methods: {
        sendOTPForUserDelete() {
      // console.log('send opt to confirm remove... ');
      this.displayOtpInput = true

      //display otp input
      // when confirmed
      //send 'prov_terminate_user'
    },
    onFinish() {
      this.displayOtpInput = false
      this.dataValue = false
       // when confirmed
      //send 'prov_terminate_user'
    }
    }
}
</script>